import Shared from "./shared";
import moment from "moment";

export default class Filters {
  public static mask(value: string) {
    if (!value) return "";
    value = value.toString();
    const firstFour = value.substring(0, 4);
    const lastFour = value.substring(value.length - 4, value.length);
    return `${firstFour}***********${lastFour}`;
  }
  public static formatDate(value: string) {
    if (!value) return "";
    return moment(value).format(Shared.dateFormat);
  }
  public static formatDateTime(value: string) {
    if (!value) return "";
    return moment(value).format(Shared.dateTimeFormat);
  }
  public static formatHourMinute(value: number) {
    if (!value) return "";
    if (value < 0) value = 0;
    return moment.utc(value * 1000).format("mm:ss");
  }

  public static truncate(value: string, length: number) {
    if (!value) return "";
    return value.length > length ? value.substr(0, length) + "..." : value;
  }

  public static difference(value: string): string {
    if (!value) return "";

    const from: moment.Moment = moment(value);
    const to: moment.Moment = moment();

    const minutes = to.diff(from, "minutes");
    if (minutes < 1) {
      return "Few Seconds ago";
    }
    if (minutes >= 1 && minutes < 60) {
      return `${minutes} minute${minutes === 1 ? "" : "s"} ago`;
    }
    const hours = to.diff(from, "hours");
    if (hours >= 1 && hours < 24) {
      return `${hours} hour${hours === 1 ? "" : "s"} ago`;
    }
    const days = to.diff(from, "days");
    if (days >= 1 && days < 6) {
      return from.format("dddd, HH:mm");
    }
    if (days >= 6 && days <= to.daysInMonth()) {
      return from.format("DD MMMM, HH:mm");
    }
    const month = to.diff(from, "months");
    if (month >= 1 && month < to.month() && from.year() === to.year()) {
      return from.format("DD MMMM, HH:mm");
    }
    return from.format("DD-MM-YYYY HH:mm");
  }

  public static diffToString(value: number) {
    if (!value) return "";
    const duration = moment.duration(value * 1000);
    const days = duration.days(),
      hrs = duration.hours(),
      mins = duration.minutes(),
      secs = duration.seconds();

    if (days > 0) {
      return `${days}d ${hrs}h`;
    }
    if (hrs > 0) {
      return `${hrs}h ${mins}m`;
    }
    return `${mins}m ${secs}s`;
  }

  public static upperCase(value: string) {
    if (!value) return "";
    return value.toLocaleUpperCase();
  }
}
